import { render, staticRenderFns } from "./SearchFilterLabel.vue?vue&type=template&id=7de4a51c"
import script from "./SearchFilterLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchFilterLabel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports